// banner-rotate.liquid js start (finite mobile swiper)
(function () {
  const MOBILE_MAX = 899;
  const mm = window.matchMedia(`(max-width: ${MOBILE_MAX}px)`);

  const instances = new Map();

  function createSwiper(el) {
    const sectionId = el.getAttribute('data-section-id');
    const space = parseInt(el.getAttribute('data-space') || '48', 10);
    const swiperEl = el.querySelector('.usp-swiper');
    if (!swiperEl) return;

    // Finite, manual swipe — no loop, no autoplay, no freeMode
    const swiper = new Swiper(swiperEl, {
      slidesPerView: 'auto',
      spaceBetween: space,
      loop: false,               // ⛔ no infinite
      allowTouchMove: true,
      speed: 400,                // normal swipe animation
      freeMode: false,           // ⛔ no momentum marquee
      watchOverflow: true,       // disables if not enough slides
      resistanceRatio: 0.85
    });

    instances.set(sectionId, swiper);
  }

  function destroySwiper(el) {
    const sectionId = el.getAttribute('data-section-id');
    const swiper = instances.get(sectionId);
    if (swiper && swiper.destroy) {
      swiper.destroy(true, true);
      instances.delete(sectionId);
    }
  }

  function handle() {
    document.querySelectorAll('.usp-strip__swiper').forEach((el) => {
      const id = el.getAttribute('data-section-id');
      if (mm.matches) {
        if (!instances.get(id)) createSwiper(el);
      } else {
        destroySwiper(el);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', handle);
  } else {
    handle();
  }
  mm.addEventListener('change', handle);

  // Shopify theme editor support
  document.addEventListener('shopify:section:load', handle);
  document.addEventListener('shopify:section:unload', handle);
})();
// banner-rotate.liquid js end


document.addEventListener('DOMContentLoaded', () => {
  const DURATION = 320; // ms
  const accordions = document.querySelectorAll('.product__accordion details');
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  accordions.forEach(det => {
    const summary = det.querySelector('summary');
    const content = det.querySelector('.accordion__content');
    if (!summary || !content) return;

    let running; // current transitionend handler (to cancel)

    // Base styles
    content.style.overflow = 'hidden';
    content.style.willChange = 'height';

    // Initial state
    if (det.open) {
      content.removeAttribute('hidden');
      content.style.height = 'auto';
    } else {
      content.setAttribute('hidden', '');
      content.style.height = '0px';
    }

    /** Cancel any ongoing transition and lock current height in px */
    const lockCurrentHeight = () => {
      if (running) {
        content.removeEventListener('transitionend', running);
        running = undefined;
      }
      const cur = content.getBoundingClientRect().height;
      content.style.transition = 'none';
      content.style.height = `${cur}px`;
      // force reflow to lock
      content.getBoundingClientRect();
    };

    const animateTo = (targetPx, { onEnd, skipAnim = false } = {}) => {
      if (skipAnim || reduced) {
        content.style.transition = 'none';
        content.style.height = targetPx === 'auto' ? 'auto' : `${targetPx}px`;
        onEnd && onEnd();
        return;
      }

      // enable transition and go
      content.style.transition = `height ${DURATION}ms ease`;
      if (targetPx === 'auto') {
        // from fixed px → auto: first animate to scrollHeight, then snap to auto at end
        const finalPx = content.scrollHeight;
        content.style.height = `${finalPx}px`;
        running = () => {
          content.style.transition = 'none';
          content.style.height = 'auto';
          running = undefined;
          onEnd && onEnd();
        };
        content.addEventListener('transitionend', running, { once: true });
      } else {
        // to a numeric px (usually 0)
        content.style.height = `${targetPx}px`;
        running = () => {
          content.style.transition = 'none';
          running = undefined;
          onEnd && onEnd();
        };
        content.addEventListener('transitionend', running, { once: true });
      }
    };

    det.addEventListener('toggle', () => {
      // Always respond, even if user clicks repeatedly
      const opening = det.open;

      // Ensure element is in the right visibility state before measuring
      if (opening) {
        content.removeAttribute('hidden');
      }

      // 1) lock current height (cancels any in-flight anim)
      lockCurrentHeight();

      // 2) compute targets and animate
      if (opening) {
        // go from current px → target px → snap to auto
        animateTo('auto', {
          onEnd: () => { /* nothing else */ }
        });
      } else {
        // from current px (or auto) → 0, then hide
        // If currently auto (opened & idle), convert to px first
        if (getComputedStyle(content).height === 'auto') {
          content.style.height = `${content.scrollHeight}px`;
          content.getBoundingClientRect(); // reflow
        }
        animateTo(0, {
          onEnd: () => {
            content.setAttribute('hidden', '');
          }
        });
      }
    });
  });
});

